import React, { useState } from 'react';
import './index.css';
import clsx from 'classnames';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';

const Service = () => {
  const [active, setActive] = useState('1');

  const onSelect = (value) => {
    setActive(value);
  };

  const serviceList = [
    {
      name: '检测服务',
      id: '1',
      desc: '提供安全工器具、施工机具、电力物资、电动工具、工程材料、光伏电站等产品的相关性能检测服务。',
    },
    {
      name: '校准服务',
      id: '2',
      desc: '提供检测设备与仪器仪表的一站式校准服务，覆盖上门取件、代送校准及样件返回等环节，全过程高效、可靠。',
    },
    {
      name: '抽样服务',
      id: '3',
      desc: '承接各类产品批量抽样业务，依据相关标准实施统计抽样，保障样本代表性。',
    },
    {
      name: '科技项目合作',
      id: '4',
      desc: '承接各类科技项目，提供试验检测全流程技术合作，涵盖方案制定、数据验证及成果输出。',
    },
    {
      name: '标准验证服务',
      id: '5',
      desc: '开展新标准技术参数与试验方法验证，为标准编制提供详细、准确的数据支撑。',
    },
  ];

  const serviceTextList = [
    {
      title: '高效',
      desc: '高自动化程度的实验室检测设备',
    },
    {
      title: '专业',
      desc: '高检测水平/专业化的检测人员',
    },
    {
      title: '服务质量',
      desc: '对大批量送检样品提供上门取件、检后送还提供上门检测服务',
    },
  ];

  const activeItem = serviceList.find((item) => item.id === active);
  return (
    <div className={clsx('service')}>
      <div className={clsx('service-title')}>服务项目</div>
      <div className={clsx('service-typeList')}>
        {serviceList?.map((item, index) => {
          return (
            <div
              key={index}
              className={clsx('service-typeList_item', {
                typeItemActive: active === item.id,
                line: active === item.id,
              })}
              onClick={() => onSelect(item.id)}
            >
              {item.name}
            </div>
          );
        })}
      </div>
      <QueueAnim
        className={clsx('service-content')}
        delay={100}
        type={['right', 'left']}
      >
        <div className={clsx('service-content_img')} />
        <div className={clsx('service-content_text-list')}>
          {serviceTextList.map((item, index) => {
            return (
              <div
                className={clsx('service-content_text-list_item')}
                key={index}
              >
                <div className={clsx('service-content_text-list_item-title')}>
                  {item.title}
                </div>
                <div className={clsx('service-content_text-list_item-desc')}>
                  {item.desc}
                </div>
              </div>
            );
          })}
        </div>
        <QueueAnim
          animConfig={[
            { opacity: [1, 0], translateX: [0, 150] },
            { opacity: 0, translateX: 0 },
          ]}
          duration={1000}
        >
          {activeItem ? (
            <div className={clsx('service-content_item')} key={activeItem.name}>
              <div className={clsx('service-content_item-title')}>
                {activeItem.name}
              </div>
              <div className={clsx('service-content_item-desc')}>
                {activeItem.desc}
              </div>
            </div>
          ) : null}
        </QueueAnim>
      </QueueAnim>
      <div className={clsx('service-small')}>
        <div className={clsx('service-small-content')}>
          {activeItem ? (
            <div
              className={clsx('service-small-content_item')}
              key={activeItem.name}
            >
              <TweenOne
                className={clsx('service-content_item-title')}
                animation={{ y: 80, opacity: 0, type: 'from' }}
              >
                {activeItem.name}
              </TweenOne>
              <TweenOne
                className={clsx('service-content_item-desc')}
                animation={{ y: 100, opacity: 0, type: 'from', delay: 100 }}
              >
                {activeItem.desc}
              </TweenOne>
            </div>
          ) : null}
          <div className={clsx('service-small-content_item-line')} />
          <div className={clsx('service-small-content_desc')}>
            {serviceTextList?.map((item, index) => {
              return (
                <div
                  className={clsx('service-small-content_desc-block')}
                  key={index}
                >
                  <div
                    className={clsx('service-small-content_desc-block-title')}
                  >
                    {item.title}
                  </div>
                  <div
                    className={clsx('service-small-content_desc-block-desc')}
                  >
                    {item.desc}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
